import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {Store} from '@gongxigames/framework/core';

export const getOrientation = <T extends {portrait: any; landscape: any;}>(field: T): any => {
    return Store.computed(() =>
        slotStore.stage_isPortrait.value ? field.portrait : field.landscape
    );
};